import { render } from "./AccountManagement.page.vue?vue&type=template&id=4b2abe00&ts=true"
import script from "./AccountManagement.page.vue?vue&type=script&lang=ts"
export * from "./AccountManagement.page.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/anisen/datamanagerweb/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__